import Swiper from 'swiper'
import {Navigation} from 'swiper/modules'
import 'swiper/css'

export default class ImageSlider {
    private imageSliders: NodeListOf<HTMLElement>

    constructor() {
        this.imageSliders = document.querySelectorAll('.ce-image-slider')
        this.init()
    }

    private init() {
        if (!this.imageSliders) return

        for (const slider of this.imageSliders) {
            // Loop mode leaves blank areas when there are fewer than 5 slides
            const slideCount = slider.querySelectorAll('.swiper-slide').length
            const canLoop = slideCount >= 5

            // Init slider
            new Swiper(slider.querySelector('.swiper') as Element, {
                modules: [Navigation],
                slidesPerView: 2,
                freeMode: true,
                spaceBetween: 32,
                centeredSlides: true,
                loop: canLoop,
                rewind: !canLoop,
                initialSlide: canLoop ? 0 : 1,
                navigation: {
                    nextEl: slider.querySelector(
                        '.swiper-button-next'
                    ) as HTMLElement,
                    prevEl: slider.querySelector(
                        '.swiper-button-prev'
                    ) as HTMLElement,
                },
            })

            // Configure lightbox
            const slides = slider.querySelectorAll(
                '.swiper-slide'
            ) as NodeListOf<HTMLElement>
            const lightbox = slider.querySelector(
                '.image-slider__lightbox'
            ) as HTMLElement
            const lightboxImage = lightbox.querySelector(
                '.image-slider__lightbox-image'
            ) as HTMLImageElement
            const lightboxClose = lightbox.querySelector(
                '.image-slider__lightbox-close'
            ) as HTMLButtonElement

            slides.forEach((slide) => {
                slide.addEventListener('click', () => {
                    const imageUrl = slide.dataset.imageUrl

                    if (imageUrl) {
                        lightboxImage.src = imageUrl
                        lightboxClose.disabled = false
                        lightbox.classList.remove(
                            'pointer-events-none',
                            'opacity-0'
                        )
                    }
                })
            })

            const closeLightbox = () => {
                lightbox.classList.add('pointer-events-none', 'opacity-0')

                setTimeout(() => {
                    lightboxImage.src = ''
                    lightboxClose.disabled = true
                }, 150)
            }

            document.addEventListener('keyup', (event) => {
                if (event.key === 'Escape') {
                    closeLightbox()
                }
            })
            lightbox.addEventListener('click', (event) => {
                if (event.target !== lightboxImage) {
                    closeLightbox()
                }
            })
        }
    }
}
